export default __webpack_public_path__ + "static/media/july_2025_1.14eb71d6.jpg";